import React from 'react';
import { Typography as MuiTypography } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SlabTypography = styled(MuiTypography)`
  font-family: ${(props) => props.theme.typography.fontFamilySlab}, serif;
  font-weight: ${(props) => props.theme.typography.fontWeightSlab};
  font-style: italic;
`;

function Typography({ children, slab = false, ...restProps }) {
  const Component = slab ? SlabTypography : MuiTypography;

  return <Component {...restProps}>{children}</Component>;
}

Typography.propTypes = {
  slab: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Typography;
